var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "myExamGrades" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("div", { staticClass: "information" }, [
              _c("div", { staticClass: "informationCenter" }, [
                _c(
                  "div",
                  { staticClass: "informationTitle" },
                  [_c("Title", { attrs: { text: "我的成绩" } })],
                  1
                ),
                _c("div", { staticClass: "elTabs" }, [
                  _c("div", { staticClass: "averageScoreClass" }, [
                    _vm._v("平均分: "),
                    _vm.disGeneralDataList && _vm.disGeneralDataList.acg_score
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.disGeneralDataList.acg_score)),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "informationDiv" },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "99%" },
                          attrs: {
                            slot: "list",
                            data: _vm.disGeneralDataList.course_data,
                            headerRowClassName: "uni-primary-table-header",
                            stripe: "",
                            border: "",
                          },
                          slot: "list",
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "start_year",
                              align: "center",
                              label: "学年",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "course_semester",
                              align: "center",
                              label: "学期",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "course_title_copy",
                              align: "center",
                              label: "课程",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "score",
                              align: "center",
                              label: "最终成绩",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }